import React from 'react';
import AboutMe from '../components/AboutMe/AboutMe';

const About = () => <AboutMe />;
export default About;
